export function getEndpointUrl(shouldUpdate: boolean, url: string, host: string = window.location.host): string {
  return shouldUpdate && !host.includes('localhost')
    ? url.replace('privatschutz', 'apigee')
    : url;
}
